import { INPUT_TYPES } from '../utils/constants.js';
import { default as GALLERY_CONSTS } from '../../common/constants/index.js';
import optionsMap from '../../core/helpers/optionsMap.js';
export default {
    title: 'Horizontal Navigation Duration',
    isRelevant: (options) => options[optionsMap.layoutParams.structure.scrollDirection] ===
        GALLERY_CONSTS[optionsMap.layoutParams.structure.scrollDirection].HORIZONTAL,
    isRelevantDescription: 'Set a Horizontal gallery ("Scroll Direction" as "Horizontal").',
    type: INPUT_TYPES.NUMBER,
    default: 400,
    description: `The time in milliseconds it takes to scroll to the next item`,
};
//# sourceMappingURL=behaviourParams_gallery_horizontal_navigationDuration.js.map